import { Keyboard, ScrollView, StyleSheet, Text, TouchableWithoutFeedback, View } from "react-native";
import * as Colors from "../../styles/colors"
import * as Fonts from "../../styles/typography"
import PageTitle from "../../components/PageTitle";
import Credencial from "./components/Credential";
import IconButton from "../../components/ButtonIcon";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { useState } from "react";
import ClientCredential from "../../models/clientCredential";
import { AddCredential } from "../../services/Api/credential";
import BetterAlert from "../../components/BetterAlert";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { IS_WEB } from "@services/Config";
export default function CredentialForm({ navigation, route }) {
    const [numberCredential, setNumberCredential] = useState("")
    const [validNumberCredential, setValidNumberCredential] = useState({
        isValid: true,
        invalidMessage: "Credencial inválida, deve ser maior que 0 e menor que 10 números",
    });
    const credentialMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    const params = route.params
    const [showAlert, setShowAlert] = useState({})


    const SaveCredential = () => {
        let valid = true

        if (numberCredential.length == 0) {
            valid = false
            setValidNumberCredential({ ...validNumberCredential, isValid: false })
        } else {
            setValidNumberCredential({ ...validNumberCredential, isValid: true })
        }

        if (valid) {
            //Chamada da Api para salvar o veiculo
            let clientCredential = new ClientCredential(numberCredential, params.idContract)
            AddCredential(clientCredential).then((value) => {
                setShowAlert({
                    type: "success",
                    title: "Credencial cadastrada",
                    // message: value.message,
                    show: true,
                    confirmText: "OK",
                    pressConfirm: () => {
                        setShowAlert({ show: false });
                        navigation.goBack()
                    },
                    showConfirmButton: true,
                });
            }).catch((value) => {
                setShowAlert({
                    type: "alert",
                    title: "Oops",
                    message: (value.erro ?? value.message) ?? "Ocorreu um erro ao tentar salvar a credencial",
                    show: true,
                    confirmText: "OK",
                    pressConfirm: () => {
                        setShowAlert({ show: false });
                    },
                    showConfirmButton: true,
                });
            })
        }
    }

    return <PageTitle navigation={navigation} title={"Adicionar Credencial"}>
        <KeyboardAwareScrollView
            style={{ flex: 1, backgroundColor: Colors.WHITE }}
            keyboardShouldPersistTaps={"always"}
        >
            <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
                <ScrollView keyboardShouldPersistTaps={"always"}>
                    <View style={styles.principalView}>
                        <Credencial numberCredential={numberCredential} />
                        <CaixaTextoInputIcone
                            iconName={"card-bulleted-outline"}
                            placeholderInput={"Número da credencial"}
                            onChangeTextInput={(numberCredential) => setNumberCredential(numberCredential)}
                            value={numberCredential}
                            keyboardType={"numeric"}
                            styleBox={{ width: "100%", marginTop: 16 }}
                            {...validNumberCredential}
                            maskInput={credentialMask}
                        />
                    </View>
                    <IconButton
                        iconName={"check-bold"}
                        textoBotao={"Salvar"}
                        estilo={{
                            backgroundColor: Colors.SUCCESS,
                            width: "100%",
                        }}
                        onPress={() => SaveCredential()}
                    />
                    <BetterAlert {...showAlert} />
                </ScrollView>
            </TouchableWithoutFeedback>
        </KeyboardAwareScrollView>
    </PageTitle>
}

const styles = StyleSheet.create({
    principalView: {
        flex: 1,
        marginTop: 8
    },
})